/**
 * Добавляет возможность сравнения параметров в условных операторах.
 *
 * @param {string} a Первый параметр.
 * @param {string} b Второй параметр.
 * @return {boolean} Результат сравнения.
 */
export default function(a, b) {
    return a === b;
}
